import { render, staticRenderFns } from "./CuratedTour.vue?vue&type=template&id=33aa710c&"
import script from "./CuratedTour.vue?vue&type=script&lang=js&"
export * from "./CuratedTour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CuratedTour.vue"
export default component.exports